/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { PaymentApiConfiguration } from '../payment-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PamInstallmentPaymentExecuteRequestDtoDto } from '../models/pam-installment-payment-execute-request-dto-dto';
import { PamPaymentLinkResponseDto } from '../models/pam-payment-link-response-dto';


/**
 * the PamCommandInstallmentExecutePaymentLink API
 */
@Injectable({
  providedIn: 'root',
})
export class PamCommandInstallmentExecutePaymentLinkService extends BaseService {
  constructor(
    config: PaymentApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation installmentUidPaymentExecutePost
   */
  static readonly InstallmentUidPaymentExecutePostPath = '/installment/{uid}/payment/execute';

  /**
   * Execute payment for installment.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `installmentUidPaymentExecutePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  installmentUidPaymentExecutePost$Response(params: {
    uid: string;
    body: PamInstallmentPaymentExecuteRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PamPaymentLinkResponseDto>> {

    const rb = new RequestBuilder(this.rootUrl, PamCommandInstallmentExecutePaymentLinkService.InstallmentUidPaymentExecutePostPath, 'post');
    if (params) {
      rb.path('uid', params.uid, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PamPaymentLinkResponseDto>;
      })
    );
  }

  /**
   * Execute payment for installment.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `installmentUidPaymentExecutePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  installmentUidPaymentExecutePost(params: {
    uid: string;
    body: PamInstallmentPaymentExecuteRequestDtoDto
  },
  context?: HttpContext

): Observable<PamPaymentLinkResponseDto> {

    return this.installmentUidPaymentExecutePost$Response(params,context).pipe(
      map((r: StrictHttpResponse<PamPaymentLinkResponseDto>) => r.body as PamPaymentLinkResponseDto)
    );
  }

}
